

























































import CancelButton from '@/components/buttons/CancelButton.vue'
import CancelPublishedTenderButton from '@/components/buttons/CancelPublishedTenderButton.vue'
import CaptchaSubmitButton from '@/components/buttons/CaptchaSubmitButton.vue'
import DownloadButton from '@/components/buttons/DownloadButton.vue'
import { ingoingDirection } from '@/constants/capacityDirections'
import { UserRoles } from '@/enums/UserRoles'
import { ProcurementStatus } from '@/services/myTender/types'
import TenderService from '@/services/tender'
import { TenderDTO, TenderWithOffersDTO } from '@/services/tender/types'
import { errorMessages } from '@/utils/helpers'
import CommissionerSection from '@/views/Tender/components/CommissionerSection.vue'
import EvaluationDetailsHeader from '@/views/Tender/Evaluation/EvaluationDetailsHeader.vue'
import EvaluationOffers from '@/views/Tender/Evaluation/EvaluationOffers.vue'
import { AxiosError } from 'axios'
import Vue from 'vue'

export default Vue.extend({
  name: 'EvaluateTender',
  components: {
    CancelPublishedTenderButton,
    CommissionerSection,
    DownloadButton,
    EvaluationOffers,
    EvaluationDetailsHeader,
    CaptchaSubmitButton,
    CancelButton,
  },
  props: { type: { type: String, default: '' } },
  data(): {
    id: string
    procurement: TenderWithOffersDTO
    ingoingDirection: string[]
    TenderService: typeof TenderService
  } {
    const id = 'id' in this.$route.params && this.$route.params.id

    if (!id) {
      throw new Error('EvaluateTender is missing required route param id')
    }

    return {
      id,
      ingoingDirection,
      procurement: {
        id: 0,
        name: '',
        description: '',
        publishDate: '',
        endDate: '',
        publishTime: '',
        endTime: '',
        type: '',
        status: '',
        lots: [],
        isLimited: false,
        timeRemaining: 0,
        direction: '',
        termsAndConditions: '',
        commissioners: [],
        creator: undefined,
        comments: '',
        offerValidityHours: 0,
        offerValidityMinutes: 0,
      } as TenderWithOffersDTO,
      TenderService,
    }
  },
  computed: {
    procurementWithBids(): TenderDTO {
      return {
        ...this.procurement,
        hasOwnBids: false,
        offersReceived: undefined,
      } as TenderDTO
    },
    downloadableLotBids(): boolean {
      return [
        ProcurementStatus.EVALUATING_OFFERS,
        ProcurementStatus.EVALUATING_EXPIRED,
        ProcurementStatus.CLOSED,
      ].includes(this.procurement.status as ProcurementStatus)
    },
    cancelable(): boolean {
      return (
        (this.procurement.status === ProcurementStatus.PUBLISHED ||
          this.procurement.status === ProcurementStatus.EVALUATING_OFFERS) &&
        !!this.procurement.id
      )
    },
    procurementId(): number {
      return this.procurement.id || 0
    },
    loggedInRole(): UserRoles {
      return this.$store.getters?.role
    },
    canCancelTender(): boolean {
      return [UserRoles.admin, UserRoles.commissioner].includes(this.loggedInRole as UserRoles)
    },
  },
  methods: {
    async fetchItem(): Promise<void> {
      const loader = this.$loading.show()
      try {
        const { data } = await TenderService.offers(this.id)
        this.procurement = data.data
      } finally {
        loader.hide()
      }
    },
    async redirectBack(): Promise<void> {
      await this.$router.push({
        name: this.type === 'buy' ? 'BuyingTenders' : this.type === 'sell' ? 'SellingTenders' : '',
      })
    },
    updateData(data: TenderWithOffersDTO): void {
      this.procurement = data
    },
    async submit(): Promise<void> {
      const loader = this.$loading.show()
      try {
        const response = await TenderService.complete(this.id, { comments: this.procurement.comments || '' })
        if (response) {
          this.$toast.success(response.data.message)
        }
        await this.redirectBack()
      } catch (err: unknown) {
        const axiosError = err as AxiosError
        if (axiosError?.response?.data) {
          this.$toast.error(errorMessages(axiosError.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
  },
  mounted() {
    this.fetchItem()
  },
})
